import service from "./service"

const uploadFile = async (data) => {
    return service(data)
}

export default uploadFile
